import { t } from 'ember-intl';
import Avatar from '../avatar.gjs';
import Component from '@glimmer/component';
import styles from './item-content.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class ContactListItemItemContent extends Component {
  get scopeIndicatorType() {
    return this.args.isClient ? 'messaging-client-icon' : 'messaging-user-icon';
  }

  <template>
    <div class={{styles.component}}>
      <Avatar @users={{@users}} @isCouple={{@isCouple}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names" data-test-user-names>{{@userNames}}</span>
          {{#if @groupMessagingEnabled}}
            <span class="scope-indicator {{this.scopeIndicatorType}}" data-test-scope-indicator>
              {{svgJar this.scopeIndicatorType}}
            </span>
          {{/if}}
        </div>
        {{#if @isDisabled}}
          <span class="disabled-notice" data-test-disabled-notice>
            {{t "emc.contact_list_item.disabled_notice"}}
          </span>
        {{/if}}
      </div>
    </div>
  </template>
}
